export default class Custom {
  addCode () {
    const filterGroups = document.querySelectorAll('.mr-filters')

    filterGroups.forEach(group => {
      const firstLi = group.querySelector('li')

      if (firstLi) {
        firstLi.classList.add('active')
      }

      group.querySelectorAll('li').forEach(li => {
        li.addEventListener('click', function () {
          group.querySelectorAll('li').forEach(item => {
            item.classList.remove('active')
          })

          this.classList.add('active')
        })
      })
    })

    const url = 'https://api.open-meteo.com/v1/forecast?latitude=46.21&longitude=6.1&current=temperature_2m,rain,snowfall,wind_speed_10m,wind_direction_10m&hourly=temperature_2m,rain,snowfall,wind_direction_180m&timezone=auto'

    const temperatureElement = document.querySelector('.temperature')
    const kmsElement = document.querySelector('.kms')
    const weatherIconElement = document.querySelector('.weather-icon')

    const convertDirection = degrees => {
      const directions = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW']
      const index = Math.round(degrees / 22.5)
      return directions[index % 16]
    }

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('The request failed')
        }
        return response.json()
      })
      .then(data => {
        console.log(data)
        temperatureElement.textContent = `${data.current.temperature_2m.toFixed(0)}°C`
        const windDirection = convertDirection(data.current.wind_direction_10m)
        kmsElement.textContent = `${windDirection} - ${data.current.wind_speed_10m.toFixed(0)} km/h`

        if (data.current.rain > 0) {
          weatherIconElement.innerHTML = '<i class='
          fa - solid
          fa - cloud - rain
          '></i>'
        } else if (data.current.snowfall > 0) {
          weatherIconElement.innerHTML = '<i class='
          fa - regular
          fa - snowflake
          '></i>'
        } else {
          if (weatherIconElement) {
            weatherIconElement.innerHTML = '<i class='
            fa - regular
            fa - sun
            '></i>'
          }
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error)
      })

    window.addEventListener('scroll', () => {
      const navbar = document.querySelector('.navbar')
      if (window.scrollY > 0) {
        navbar.classList.add('shadow')
      } else {
        navbar.classList.remove('shadow')
      }
    })

    const revealItems = document.querySelectorAll('.timeline-panel')

    const revealOnScroll = () => {
      revealItems.forEach((item, index) => {
        const revealLeft = item.getBoundingClientRect().left
        const windowHeight = window.innerHeight
        if (revealLeft < windowHeight) {
          setTimeout(() => {
            item.classList.add('revealed')
          }, 200 * index)
        }
      })
    }

    if (revealItems[0]) {
      revealItems[0].classList.add('revealed')
    }

    window.addEventListener('scroll', revealOnScroll)

    return this
  }
}
